import React, { useState } from "react";
import "./Head.css"; // لو Video محتاج Head2.css بدلها
import ScrollProgressBar from "../../../componant/ScrollProgressBar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

const Head = ({ darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      localStorage.clear();
      navigate("/Mr.Monem");
    } catch (error) {
      navigate("/signin");
    }
  };

  // ====================== 🔥 ROUTE-BASED UI ======================
  const hasToken = !!localStorage.getItem("authToken");

  // 📌 1 — صفحة PricingCard
  if (location.pathname === "/Card") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/mo/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/Mr.Monem")}
              />            </div>

            <div className="buttons">
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
              <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}

              </button>
            </div>
          </div>
        </section>
        <ScrollProgressBar />
      </>
    );
  }

  // 📌 2 — صفحة ProfileCard
  if (location.pathname === "/Cardlec") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/mo/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/Mr.Monem")}
              />           </div>

            <div className="buttons">
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
              <button
                onClick={() => navigate("/Card")}
                className="btn login"
              >
                الحصص الشهرية
              </button>
              <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>
            </div>
          </div>
        </section>
        <ScrollProgressBar />
      </>
    );
  }

  // 📌 3 — صفحة Video  🔥🔥
  if (location.pathname === "/VIDEOs") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/mo/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/Mr.Monem")}
              />           </div>

            <div className="buttons">
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>

              <button
                onClick={() => navigate("/Cardlec")}
                className="btn login"
              >
                المحاضرات
              </button>
              <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>
            </div>
          </div>
        </section>

        <ScrollProgressBar />
      </>
    );
  }

  // 📌 4 — الصفحات العادية (Default Header)
  return (
    <>
      <section className="head">
        <div className="container flexSB">
          <div className="left-logo">
            <img
              src="/images/mo/logos.jpg"
              alt="Logo"
              className="logo-img"
              onClick={() => navigate("/Mr.Monem")}
            />          </div>

          <div className="buttons flex items-center gap-2">

            <button onClick={toggleDarkMode} className="btn darkmode">
              {darkMode ? "☀️ Light" : "🌙 Dark"}
            </button>

            {!hasToken ? (
              <>
                <button onClick={() => navigate("/MakeAccount")} className="btn signup">
                  إنشئ حسابك
                </button>

                <button onClick={() => navigate("/Signin")} className="btn login">
                  تسجيل الدخول
                </button>
              </>
            ) : (
              <button onClick={() => navigate("/Teachers")} className="btn login">
                مدرسيني
              </button>
            )}

          </div>

        </div>
      </section>

      <ScrollProgressBar />
    </>
  );
};

export default Head;
